import React from "react";
import CapsuleImageVertical from "../../Components/CapsuleImageVertical/CapsuleImageVertical";
import SectionTwoImage1280 from "../../Assets/Images/ab-1-Male-1280-1919.png";
import SectionTwoImage1920 from "../../Assets/Images/ab-1-Male-1920.png";
import SectionTwoImageMobile from "../../Assets/Images/Values-1-Mob.png";
import iambestImage from "../../Assets/Images/am-best-nuevo.png";
import { useTranslation } from "../../Hooks/useTranslation"; // Import the hook

const AmBest = () => {
  const translations = useTranslation(); // Get translations dynamically
  return (
    <>
      <div className="flex-1">
        {/* Desktop 1280-1919 */}
        <div className="hidden lg:block [@media(min-width:1920px)]:hidden">
          <CapsuleImageVertical image={SectionTwoImage1280} />
        </div>
        {/* Desktop 1920+ */}
        <div className="hidden [@media(min-width:1920px)]:block">
          <CapsuleImageVertical image={SectionTwoImage1920} />
        </div>
        <div className="mt-8 mb-4 -mr-4 md:mr-0 md:pl-4 lg:hidden flex md:max-w-[664px] overflow-hidden md:overflow-visible">
          <img
            src={SectionTwoImageMobile}
            alt="section-two-image-mobile"
            className="w-[130%] md:w-full max-w-none md:max-w-full"
          />
        </div>
      </div>

      <div className="flex-1 mt-2 lg:mt-32 reveal-up lg:pl-0 px-4 lg:max-w-[295px] xl:max-w-none">
        <h3 className="md:text-[18px] md:leading-[21px] md:tracking-[-0.36px] xl:text-[24px] xl:leading-[28px] xl:tracking-normal font-semibold mb-4 text-[16px] leading-[20px] extra-title36">
          {translations.AmBestTitle}
        </h3>

        <p
          className="text-[14px] md:text-[11.5px] md:leading-[18px] xl:text-[14px] xl:leading-[22px] leading-[22px] mb-4 [@media(min-width:1920px)]:mb-6 text-justify extra-para-vs"
          dangerouslySetInnerHTML={{
            __html: translations.AmBestDescription1,
          }}
        ></p>
        <p className="text-[14px] md:text-[11.5px] md:leading-[18px] xl:text-[14px] xl:leading-[22px] leading-[22px] mb-4 [@media(min-width:1920px)]:mb-6 text-justify extra-para-vs">
          {translations.AmBestDescription2}
        </p>
        <img
          src={iambestImage}
          className="max-w-[150px] max-h-[150px] lg:max-w-[124.5px] lg:max-h-[47.25px] xl:max-w-[150px] xl:max-h-[150px] mt-2 hidden lg:block iambest-logo"
          alt="iambest-logo"
        />
      </div>
    </>
  );
};

export default AmBest;
